// CacheKey 378bc04f5d7a5afd147e346b60496a44
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  ko: {
    time_zones: {
      est: "동부 표준시",
      edt: "동부 표준시",
      cst: "중부 표준시",
      cdt: "중부 표준시",
      mst: "산악 표준시",
      mdt: "산악 표준시",
      pst: "태평양 표준시",
      pdt: "태평양 표준시",
      hst: "하와이–알류산 표준시",
      hdt: "하와이–알류산 표준시",
      akst: "알래스카 표준시",
      akdt: "알래스카 표준시"
    }
  }
}

